import React from 'react';
import Button from './Button';
import  useScrollToTop from './useScrollToTop';
import spaciousHouseOverview from '../img/elevation_img_11.avif'; // Replace with your actual image
import spaciousHouseGroundFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import spaciousHouseFirstFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import airyLiving from '../img/elevation_img_11.avif'; // Replace with your actual image
import wellProportionedExterior from '../img/elevation_img_11.avif'; // Replace with your actual image
import './ProjectStyles.css';

const HousePlan30x50 = () => {
  useScrollToTop();
  return (
    <div className='project-container'> {/* Using the general project container style */}
      <h2>Spacious 30x50 House Plan (1500 sq ft): Designed for Comfortable Family Living</h2>
      <img className='project-image' src={spaciousHouseOverview} alt="30x50 House Overview" loading="lazy" />
      <div className='project-details'>
        <p>Explore a generously sized two-story house plan designed for a 30x50 sq ft plot (1500 sq ft). This design prioritizes spacious living areas, ample natural light, and comfortable functionality, making it an excellent choice for families in Patna, Bihar.</p>

        <h3>Design Philosophy: Emphasizing Space and Comfort</h3>
        <p>The core of this design is to maximize the potential of the 1500 sq ft plot to create a spacious and comfortable home. The two-story structure allows for well-defined living and sleeping zones, with an emphasis on creating airy and bright interiors. Good ventilation is also a key consideration for the climate in Patna.</p>

        <h3>Inspiration for Spacious Family Homes</h3>
        <div className='inspiration-gallery'>
          {/* Replace with images inspiring spacious and comfortable family homes */}
          <img src='../img/large_open_plan_living.jpg' alt='Spacious Home Inspiration 1' className='project-image' />
          <img src='../img/well_appointed_kitchen_diner.jpg' alt='Spacious Home Inspiration 2' className='project-image' />
          <img src='../img/comfortable_master_suite.jpg' alt='Spacious Home Inspiration 3' className='project-image' />
          {/* Add more inspiration images as needed */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Detailed Floor Plans: Generous Living Areas</h3>
        <div className='floor-plan-section'>
          <h4>Ground Floor Plan (Approx. 750 sq ft)</h4>
          <img className='project-image' src={spaciousHouseGroundFloor} alt="Ground Floor Plan" loading="lazy" />
          <p>The ground floor typically features a large and welcoming living room, a spacious kitchen with a dedicated dining area, a common bathroom, and a guest bedroom or a study. The design allows for a comfortable flow between these areas, ideal for family gatherings and entertaining.</p>
          <ul>
            <li><strong>Large and Airy Living Room</strong></li>
            <li><strong>Spacious Kitchen with Dedicated Dining Area</strong></li>
            <li><strong>Guest Bedroom/Study</strong></li>
            <li><strong>Common Bathroom</strong></li>
            <li><strong>Staircase to the First Floor</strong></li>
            <li>Potential for a front porch and a small garden at the rear</li>
          </ul>
          {/* Add specific room dimensions and features here */}
        </div>

        <div className='floor-plan-section'>
          <h4>First Floor Plan (Approx. 750 sq ft)</h4>
          <img className='project-image' src={spaciousHouseFirstFloor} alt="First Floor Plan" loading="lazy" />
          <p>The first floor usually accommodates the main bedrooms, including a master bedroom with an attached bathroom and a balcony, and two or three additional well-sized bedrooms, along with another bathroom. A family lounge area is also a common feature, providing a comfortable space for relaxation.</p>
          <ul>
            <li><strong>Master Bedroom with Attached Bathroom and Balcony</strong></li>
            <li><strong>Two or Three Additional Bedrooms</strong></li>
            <li><strong>Common Bathroom</strong></li>
            <li><strong>Family Lounge/Living Area</strong></li>
            <li>Potential for an additional balcony or terrace</li>
          </ul>
          {/* Add specific room dimensions and features here */}
        </div>

        <div className='built-area-breakdown'>
          <h4>Built Area Breakdown (Approximate)</h4>
          <ul>
            <li><strong>Ground Floor:</strong> ~750 sq ft</li>
            <li><strong>First Floor:</strong> ~750 sq ft</li>
            <li><strong>Total Built Area:</strong> ~1500 sq ft</li>
            <p>*Note: These are approximate figures and can vary based on the specific architectural design.</p>
          </ul>
        </div>
      </div>

      <div className='project-details'>
        <h3>Comfortable Interiors: Light, Space, and Functionality</h3>
        <div className='interior-feature'>
          <h4>Abundant Natural Light and Ventilation</h4>
          <img className='project-image' src={airyLiving} alt="Airy Living Space" loading="lazy" />
          <p>The design emphasizes large windows and strategically placed openings to maximize natural light and ensure excellent cross-ventilation throughout the house, creating a refreshing and healthy living environment.</p>
        </div>

        <div className='interior-feature'>
          <h4>Generously Sized Rooms</h4>
          <p>The larger plot allows for generously sized rooms, providing ample space for furniture and comfortable movement.</p>
        </div>

        <div className='interior-feature'>
          <h4>Dedicated Living Zones</h4>
          <p>The two-story layout allows for clear separation between public and private living areas, enhancing functionality and privacy.</p>
        </div>

        {/* Add more interior design considerations for a spacious family home */}
      </div>

      <div className='project-details'>
        <h3>Practical Exterior: Inviting and Well-Designed</h3>
        <img className='project-image' src={wellProportionedExterior} alt="House Exterior" loading="lazy" />

        <div className='exterior-feature'>
          <h4>Attractive and Functional Design</h4>
          <p>The 30x50 plot provides ample space for an appealing and well-proportioned exterior design, with potential for landscaping and outdoor features.</p>
        </div>

        <div className='exterior-feature'>
          <h4>Durable and Weather-Resistant Materials</h4>
          <p>Choosing high-quality and weather-resistant exterior materials will ensure the durability and aesthetic appeal of the home for years to come.</p>
        </div>

        {/* Add more exterior design features */}
      </div>

      <div className='project-details'>
        <h3>Quality Considerations for Your 1500 sq ft Home</h3>
        <div className='materials-list'>
          <h4>Material Considerations</h4>
          <ul>
            <li><strong>Structure:</strong> Robust Reinforced Concrete structure designed for safety and longevity.</li>
            <li><strong>Exterior Walls:</strong> High-quality brickwork with durable plastering and paint finishes.</li>
            <li><strong>Roofing:</strong> Well-insulated and waterproof roofing system for comfort and protection.</li>
            <li><strong>Windows and Doors:</strong> Energy-efficient and secure options in UPVC or aluminum.</li>
            <li><strong>Flooring:</strong> Durable and aesthetically pleasing flooring options such as vitrified tiles, marble, or engineered wood.</li>
          </ul>
        </div>

        {/* Optional: Vaastu considerations for a larger plot */}
        {/* <h4>Vaastu Shastra Considerations (Optional)</h4>
        <p>With a larger plot, there is greater flexibility in incorporating Vaastu principles for optimal energy flow and harmony. Careful consideration of the orientation of rooms, entrances, and open spaces can be integrated into the design.</p> */}
      </div>

      {/* Optional: Location and Context in Patna */}
      {/* <div className='project-details'>
        <h3>Ideal for Comfortable Living in Patna's Residential Areas</h3>
        {locationMap && <img className='project-image' src={locationMap} alt="Location Map" />}
        <p>This 30x50 house plan is well-suited for residential areas in Patna, offering ample space for families to live comfortably and enjoy a good quality of life.</p>
        <div className='location-details'>
          <h4>Local Considerations</h4>
          <ul>
            <li>Fits well on standard to larger residential plots in Patna.</li>
            <li>Allows for a good balance of indoor and outdoor living spaces.</li>
            <li>Designed with consideration for local climate and building practices.</li>
          </ul>
        </div>
      </div> */}

      <div className='project-details'>
        <h3>Ready to Build Your Spacious Family Home?</h3>
        <p>This generous 30x50 two-story house plan provides an excellent framework for creating a spacious and comfortable home for your family in Patna. Contact experienced architects and builders to customize this plan to your specific needs and local building codes.</p>
        {/* Add your contact information or links to architectural services */}
        <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Discuss Your Custom Design</Button>
                </a>
      </div>
    </div>
  );
};

export default HousePlan30x50;